import { registerPlugin } from '@capacitor/core';
export const Talsec = registerPlugin('Freerasp', {});
//# sourceMappingURL=nativeModules.js.map